import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ModuleModal component styles
 * @returns {Function}
 */

export const useStyles = makeStyles(() =>
  createStyles({
    imageModalWrapper: {
      backgroundColor: variables.colorV2.body.background.default,
      display: 'flex',
      justifyContent: 'center',
      // height: 'calc(150vh + 24.2rem)',
      // padding: '25rem 0 0',
      position: 'absolute',
      top: 0,
      width: '100%',
      zIndex: 1,
    },

    moduleContent: {
      alignItems: 'center',
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      display: 'flex',
      padding: '2rem 1.6rem',
      position: 'relative',
      width: '100%',

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        maxWidth: '63.2rem',
        width: '63.2rem',
      },
    },

    imageWrapper: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      // border: `3px solid ${variables.color.primary.mainPurple}`,
      // borderRadius: '3px',
    },

    closeBtn: {
      padding: '3px 5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      background: variables.color.primary.mainPurple,
      top: '0rem',
      right: '0rem',
      cursor: 'pointer',
      borderRadius: '0 2px 2px 0',

      '&:hover': {
        background: variables.color.primary.mainPurple,
      },
    },

    removeBtn: {
      padding: '3px 5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      background: 'none',
      top: '3rem',
      right: '0rem',
      cursor: 'pointer',
      borderRadius: '0 2px 2px 0',

      '&:hover': {
        background: variables.color.primary.mainPurple,
      },
    },
  }),
);
